import { render, staticRenderFns } from "./Type_IB.vue?vue&type=template&id=4b78d25d&scoped=true&"
import script from "./Type_IB.vue?vue&type=script&lang=js&"
export * from "./Type_IB.vue?vue&type=script&lang=js&"
import style0 from "./Type_IB.vue?vue&type=style&index=0&id=4b78d25d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b78d25d",
  null
  
)

export default component.exports